import L from "leaflet";
import { Marker } from "react-leaflet";
import { renderToString } from "react-dom/server";

import { formatDistance } from "helpers/formatDistance";

import styles from "./map-polygon-builder.module.scss";

const DistanceLabels = ({ points }: { points: number[][] }) => {
  return (
    <>
      {[
        ...points.map((_, i, arr) => {
          if (i === arr.length - 1) {
            return [arr[i], arr[0]];
          }
          return [arr[i], arr[i + 1]];
        })
      ].map(([point1, point2], i) => {
        const [lat1, lng1] = point1;
        const [lat2, lng2] = point2;

        const distance = L.latLng(lat1, lng1).distanceTo(L.latLng(lat2, lng2));
        const formattedDistance = formatDistance(distance);

        const midLat = (lat1 + lat2) / 2;
        const midLng = (lng1 + lng2) / 2;

        const icon = L.divIcon({
          html: renderToString(
            <div className={styles["distance-label"]}>{formattedDistance}</div>
          ),
          iconAnchor: [0, 0],
          iconSize: [0, 18],
          className: "marker-reset"
        });

        return (
          <Marker
            key={i}
            position={[midLat, midLng]}
            icon={icon}
            interactive={false}
          />
        );
      })}
    </>
  );
};

export default DistanceLabels;
